import axios from "axios";
import { toast } from "react-toastify";
import * as actionTypes from "./ActionTypes";

export const AdminLogin = (email, password) => async (dispatch) => {
  dispatch({
    type: actionTypes.ADMIN_LOGIN_INIT,
  });
  const payload = {
    email,
    password,
  };
  try {
    const response = await axios.post(
      "https://app.loungebridge.com/api/admin/login",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.status === 200) {
      localStorage.setItem("authToken", response?.data?.token);

      dispatch({
        type: actionTypes.ADMIN_LOGIN_SUCCESS,
        payload: payload,
      });
      return true;
    } else {
      dispatch({
        type: actionTypes.ADMIN_LOGIN_FAIL,
        payload: "Login Failed!",
      });
      return false;
    }
  } catch (error) {
    dispatch({
      type: actionTypes.ADMIN_LOGIN_FAIL,
      payload: error.response ? error.response.data : "An error occurred",
    });
    toast.error(error?.response?.data?.message || "Login Failed!");
    return false;
  }
};

export const GetAdminProfile = () => async (dispatch) => {
  dispatch({
    type: actionTypes.GET_ADMIN_PROFILE_INIT,
  });

  try {
    const authToken = localStorage.getItem("authToken");
    const config = {
      headers: {
        Authorization: authToken ? `Bearer ${authToken}` : "",
      },
    };

    const response = await axios.get(
      "https://app.loungebridge.com/api/admin/profile",
      config
    );

    if (response.status === 200) {
      dispatch({
        type: actionTypes.GET_ADMIN_PROFILE_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      dispatch({
        type: actionTypes.GET_ADMIN_PROFILE_FAIL,
        payload: "Failed to fetch profile",
      });

      return false;
    }
  } catch (error) {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem("authToken");
      toast.error("Session expired. Please log in again.");
      window.location.href = "/login";
    } else {
      dispatch({
        type: actionTypes.GET_ADMIN_PROFILE_FAIL,
        payload: error.response ? error.response.data : "An error occurred",
      });
      toast.error(error?.response?.data?.message || "Failed to fetch profile");
    }
    return false;
  }
};

export const Getusers =
  (page = 1, search = "") =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.GET_ALL_USER_INIT,
    });

    try {
      const authToken = localStorage.getItem("authToken");
      const config = {
        headers: {
          Authorization: authToken ? `Bearer ${authToken}` : "",
        },
      };
      const response = await axios.get(
        `https://app.loungebridge.com/api/admin/all-users/normal?page=${page}&search=${search}`,
        config
      );

      if (response.status === 200) {
        dispatch({
          type: actionTypes.GET_ALL_USER_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: actionTypes.GET_ALL_USER_FAIL,
          payload: "Failed to fetch users",
        });
        toast.error("Failed to fetch users");
        return false;
      }
    } catch (error) {
      if (error.response?.status === 401 || error.response?.status === 403) {
        localStorage.removeItem("authToken");
        toast.error("Session expired. Please log in again.");
        window.location.href = "/login";
      } else {
        dispatch({
          type: actionTypes.GET_ALL_USER_FAIL,
          payload: error.response ? error.response.data : "An error occurred",
        });
        toast.error("Failed to fetch users");
      }
      return false;
    }
  };

export const GetExpertusers =
  (page = 1, search = "") =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.GET_EXPERT_USER_INIT,
    });

    try {
      const authToken = localStorage.getItem("authToken");
      const config = {
        headers: {
          Authorization: authToken ? `Bearer ${authToken}` : "",
        },
      };
      const response = await axios.get(
        `https://app.loungebridge.com/api/admin/all-users/expert?page=${page}&search=${search}`,
        config
      );

      if (response.status === 200) {
        dispatch({
          type: actionTypes.GET_EXPERT_USER_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: actionTypes.GET_EXPERT_USER_FAIL,
          payload: "Failed to fetch expert users",
        });
        toast.error("Failed to fetch expert users");
        return false;
      }
    } catch (error) {
      dispatch({
        type: actionTypes.GET_ALL_USER_FAIL,
        payload: error.response ? error.response.data : "An error occurred",
      });
      toast.error("Failed to fetch expert users");
      return false;
    }
  };

//Delete user account
export const DeleteuserAccount = (user_id) => async (dispatch) => {
  const payload = {
    user_id: user_id,
  };
  dispatch({
    type: actionTypes.DELETE_USER_INIT,
  });
  try {
    const authToken = localStorage.getItem("authToken");
    const config = {
      headers: {
        Authorization: authToken ? `Bearer ${authToken}` : "",
      },
    };
    const response = await axios.post(
      `https://app.loungebridge.com/api/admin/user/delete/${user_id}`,
      payload,
      config
    );

    if (response.status === 200) {
      dispatch({
        type: actionTypes.DELETE_USER_SUCCESS,
        payload: response.data,
      });
      toast.success("User deleted successfully!");
    } else {
      dispatch({
        type: actionTypes.DELETE_USER_FAIL,
        payload: "Failed to delete account!",
      });
      toast.error("Failed to delete account!");
      return false;
    }
  } catch (error) {
    dispatch({
      type: actionTypes.DELETE_USER_FAIL,
      payload: error.response ? error.response.data : "An error occurred",
    });
    toast.error("Failed to delete account!");
    return false;
  }
};

//GET RECYCLE DATA
export const GetRecycleuser =
  (page = 1, search = "") =>
  async (dispatch) => {
    dispatch({ type: actionTypes.GET_RECYCLE_INIT });

    try {
      const authToken = localStorage.getItem("authToken");
      const config = {
        headers: {
          Authorization: authToken ? `Bearer ${authToken}` : "",
        },
      };
      const response = await axios.get(
        `https://app.loungebridge.com/api/admin/deleted-users?page=${page}&search=${search}`,
        config
      );

      if (response.status === 200) {
        dispatch({
          type: actionTypes.GET_RECYCLE_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: actionTypes.GET_RECYCLE_FAIL,
          payload: "Failed to delete account",
        });
        toast.error("Failed to delete account");
        return false;
      }
    } catch (error) {
      dispatch({
        type: actionTypes.GET_RECYCLE_FAIL,
        payload: error.response ? error.response.data : "An error occurred",
      });
      toast.error("Failed to delete account");
      return false;
    }
  };

//RESTORE USER ACCOUNT
export const RestoreuserAccount = (id) => async (dispatch) => {
  const payload = {
    id: id,
  };
  dispatch({
    type: actionTypes.RESTORE_USER_ACCOUNT_INIT,
  });

  try {
    const authToken = localStorage.getItem("authToken");
    const config = {
      headers: {
        Authorization: authToken ? `Bearer ${authToken}` : "",
      },
    };
    const response = await axios.put(
      `https://app.loungebridge.com/api/admin/restore-user/${id}`,
      payload,
      config
    );
    if (response.status === 200) {
      dispatch({
        type: actionTypes.RESTORE_USER_ACCOUNT_SUCCESS,
        payload: response.data,
      });
      toast.success("User restored successfully!");
    } else {
      dispatch({
        type: actionTypes.RESTORE_USER_ACCOUNT_FAIL,
        payload: "Failed to restore account",
      });
      toast.error("Failed to restore account");
      return false;
    }
  } catch (error) {
    dispatch({
      type: actionTypes.GET_RECYCLE_FAIL,
      payload: error.response ? error.response.data : "An error occurred",
    });
    toast.error("Failed to restore account");
    return false;
  }
};

//GET USER FEEDBACK
export const GetUserFeedback =
  (page = 1, search = "", rating = "") =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.GET_USERS_FEEDBACK_INIT,
    });

    try {
      const authToken = localStorage.getItem("authToken");
      const config = {
        headers: {
          Authorization: authToken ? `Bearer ${authToken}` : "",
        },
      };
      const response = await axios.get(
        `https://app.loungebridge.com/api/admin/feedbacks?page=${page}&search=${search}&rating=${rating}`,
        config
      );
      if (response.status === 200) {
        dispatch({
          type: actionTypes.GET_USERS_FEEDBACK_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: actionTypes.GET_USERS_FEEDBACK_FAIL,
          payload: "Failed to fetch feedback",
        });
        toast.error("Failed to fetch feedback");
        return false;
      }
    } catch (error) {
      dispatch({
        type: actionTypes.GET_USERS_FEEDBACK_FAIL,
        payload: error.response ? error.response.data : "An error occurred",
      });
      toast.error("Failed to fetch feedback");
      return false;
    }
  };

export const DeleteFeedback = (feedback_id) => async (dispatch) => {
  const payload = {
    feedback_id,
  };
  dispatch({
    type: actionTypes.USER_FEEDBACK_INIT,
  });
  try {
    const authToken = localStorage.getItem("authToken");
    const config = {
      headers: {
        Authorization: authToken ? `Bearer ${authToken}` : "",
      },
    };
    const response = await axios.post(
      `https://app.loungebridge.com/api/admin/feedbacks/delete`,
      payload,
      config
    );

    if (response.status === 200) {
      dispatch({
        type: actionTypes.USER_FEEDBACK_SUCCESS,
        payload: response.data,
      });
      toast.success("Feedback Deleted Successfully !");
    } else {
      dispatch({
        type: actionTypes.USER_FEEDBACK_FAIL,
        payload: "Failed to delete feedback",
      });
      toast.error("Failed to delete feedback");
      return false;
    }
  } catch (error) {
    dispatch({
      type: actionTypes.DELETE_USER_FAIL,
      payload: error.response ? error.response.data : "An error occurred",
    });
    toast.error("Failed to delete feedback");
    return false;
  }
};
